export default __webpack_public_path__ + "static/media/google-frame.fa5ed5a7.svg";